import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { JobWorkInwardPopup } from './JobWorkInwardTable';
import { decryptAES } from '../../../utils/Encryption';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';

export default class JobWorkInward extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            urlId: 0,
            globalUserID: '',
            usp_Users: [],
            taxStructureList: [],
            isModalOpen: false,
            isSaving: false,
            open: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColdefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            vendorSelectedRowsForItem: [],
            partyAccountList: [],
            accountHeadList: [],
            employeeList: [],
            gatePassList: [],
            materialJobWorkInwardSelectionList: [],
            challanItemDetails: [],
            companyName: "",
            invTyleList: [
                { value: 1, label: 'INTRASTATE' },
                { value: 2, label: 'INTERSTATE' },
            ],
            jobWorkFromLIst: [
                { value: 1, label: 'FROMTESTING' },
                { value: 2, label: 'REWORKCHALLAN' },
                { value: 3, label: 'FromDisAssemble' },
                { value: 4, label: 'JobWorkChallan' },
                { value: 5, label: 'MANUALLY' },
            ],
            materialObject: {
                idMaterialJobWorkInward: 0,
                jobWorkInwardNo: '',
                updateStatus: 0,
                jobWorkInwardDate: '',
                idEmployee: 0,
                testingNo: '',
                idJobWorkFrom: 0,
                idGatepass: 0,
                invoiceDate: '',
                invoiceNo: '',
                idInv: 1,
                IdJobWork: 0,
                inwardNo: '',
                inwardDate: '',
                idVendor: '',
                inspection: '',
                deliveryCommence: "",
                transporter: "",
                address: "",
                idPlant: '',
                ididAccHead: 0,
                totalQuantity: "",
                jwTotalAmt: "",
                diffAmt: "",
                totalAmt: "",
                extraCharges: "",
                discount: "",
                taxAmt: "",
                tcsPercentage: "",
                tcsAmt: "",
                totalWithTax: "",
                finalAmt: "",
                email: "",
                contactNo: "",
                contactPerson: "",
                taxableAmt: "",
                adjustableAmt: ""
            },
            itemObject: {
                drawingNo: '',
                itemName: '',
                quantity: '',
                inwardQty: '',
                pendingQty: '',
                rate: '',
                jwRate: '',
                discount: '',
                extraCharges: '',
                remarks: '',
                keyId: null,

                idTaxGroup: 0,
                sgstAmt: '',
                cgstAmt: '',
                igstAmt: '',
                sgst: 0,
                cgst: 0,
                igst: 0,
                netTotal: ''
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                invoiceDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice date"
                        ),
                    },
                ],
                jobWorkInwardDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "jobwork inward date"
                        ),
                    },
                ],
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
            },
            validationRules: {
                inwardQty: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "inward quantity"
                        ),
                    },
                ],
                jobworkRate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "job work rate"
                        ),
                    },
                ],
                discount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "discount"
                        ),
                    },
                ],
                extraCharges: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "extra charges"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
                this.getAllUsers();
            });
        }
    }

    getAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Job Work Inward",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    this.setPermissions(permissions);
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialJobWork", "idMaterialJobWorkInward"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Job Work Inward",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Job Work Inward");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.materialObject;
        details.idMaterialJobWorkInward = id;
        this.setState({ materialObject: details }, () => {
            this.usp_Transaction_MaterialJobWorkInwardSelectbyID(this.state.materialObject.idMaterialJobWorkInward);
        });
    };

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "invoiceDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.2,
            "gatePassNo": window.innerWidth * 0.06,
            "totalQty": window.innerWidth * 0.06,
            "totalAmt": window.innerWidth * 0.06,
            "extraCharges": window.innerWidth * 0.06,
            "discount": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "jobWorkNo": window.innerWidth * 0.09,
            "jobWorkInwardDate": window.innerWidth * 0.08,
            "jobWorkFrom": window.innerWidth * 0.08,
            "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.2,
            "hsnCode": window.innerWidth * 0.06,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        this.getMasterAccountHeadSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getMasterAccountHeadSelect();
                }
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let result = data?.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                })).filter((x) => x.label === 'JOB WORK');
                let details = this.state.materialObject
                details.idGeneralProduct = data?.find(x => x.productName === 'JOB WORK')?.idGeneralProduct
                this.setState({ accountHeadList: result, materialObject: details }, () => {
                    this.getEmployeeList()
                });
            } else {
                this.getEmployeeList();
            }
        });
    }

    getEmployeeList = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idEmployee,
                    label: x.employeeName,
                }));
                this.setState({ employeeList: data }, () => {
                    this.getGatePassList();
                });
            } else {
                this.getGatePassList();
            }
        });
    }

    getGatePassList = () => {
        let request = {
            idCompany: this.state.idCompany,
            updateStatus: this.state.materialObject.updateStatus,
            idJobWorkInward: this.state.materialObject.idMaterialJobWorkInward
        }
        this.transactionStockServices.usp_Extra_GatePassSelect_ForJobWorkInward(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idGatePass,
                    label: x.gatePassNo + ' ' + x.party,
                    party: x.party
                }));
                this.setState({ gatePassList: data });
                this.getTaxStructureList()
            } else {
                this.getTaxStructureList()
            }
        });
    }

    getTaxStructureList = () => {
        // let request = {
        //     formname: "Tax Structure Master",
        //     idCompany: this.state.idCompany,
        //     allowToRateVisible: 1,
        //     idUser: 0,
        // };
        // this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
        //     if (response.statusCode == 200 && response.responseItem !== null) {
        //         let data = response.responseItem.responseContent[1];
        //         data = data.map((x) => ({
        //             idTaxStructure: x.idTaxStructure,
        //             label: x.taxStructureName,
        //             value: x.idTaxStructure,
        //             sgst: x.sgst ? x.sgst : 0,
        //             cgst: x.cgst ? x.cgst : 0,
        //             igst: x.igst ? x.igst : 0
        //         }));
        //         this.setState({ taxStructureList: data })
        //     }
        // });

        this.transactionStockServices.getMaster_TaxStructure().then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                allData = allData.map((x) => ({
                    idTaxStructure: x.idTaxStructure,
                    label: x.taxStructureName,
                    value: x.idTaxStructure,
                    sgst: x.sgst ? x.sgst : 0,
                    cgst: x.cgst ? x.cgst : 0,
                    igst: x.igst ? x.igst : 0
                }));
                this.setState({
                    taxStructureList: allData
                });
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ open: false })
        this.transactionStockServices.getInvoiceCountForJobWorkInward(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let taxableAmt = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (taxableAmt.toString().length === 1) {
                    formatted = '00' + taxableAmt;
                } else if (taxableAmt.toString().length === 2) {
                    formatted = '0' + taxableAmt;
                } else {
                    formatted = taxableAmt.toString();
                }
                let materialObject = this.state.materialObject
                materialObject.jobWorkInwardNo = formatted
                materialObject.jobWorkInwardDate = moment(new Date()).format('YYYY-MM-DD')
                this.setState({ materialObject: materialObject }, () => {
                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.getGatePassList()
                        this.resetItemObject()
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.setState({ open: false }, () => {
            let validState = this.state.validState;
            validState.isValid = true;
            validState.error = {};
            this.resetItemObject()
            this.setState({
                validState: validState
            }, () => {
                this.usp_Transaction_MaterialJobWorkInwardSelectbyID(event.data.idMaterialJobWorkInward);
            });
        })
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
        this.setState({ isModalOpen: false, });
        this.resetDetailsFields()
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        if (name === 'tcsPercentage' || name === 'adjustableAmt') {
            this.calculatePricing()
        }
        this.setState({ materialObject: details });
    }
    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }
    addJobWork = () => {
        this.setState({ itemRowData: [], challanItemDetails: [] }, () => {
            this.usp_Transaction_MaterialJobWorkSelectbyIDVendor2()
        })
    }

    usp_Transaction_MaterialJobWorkSelectbyIDVendor2 = () => {
        if (this.state.materialObject.idVendor > 0) {
            let request = {
                idCompany: this.state.idCompany,
                updateStatus: this.state.materialObject.updateStatus,
                idMaterialJobWorkInward: this.state.materialObject.idMaterialJobWorkInward,
                idVendor: this.state.materialObject.idVendor
            }
            this.transactionStockServices.usp_Transaction_MaterialJobWorkSelectbyIDVendor2(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    dynamicData.map(x => {
                        x.jobWorkDate = x.jobWorkDate ? moment(x.jobWorkDate).format('DD-MM-YYYY') : '';
                    })
                    this.setState({
                        materialJobWorkInwardSelectionList: dynamicData,
                    }, () => {
                        if (this.state.materialJobWorkInwardSelectionList.length > 0) {
                            this.usp_Transaction_MaterialJobWorkSelectbyID_PendingQty(this.state.materialJobWorkInwardSelectionList[0].idMaterialJobWork)
                        }
                    });
                }
            })
        } else {
            this.SwalServices.Alert('Please select supplier first')
        }
    }


    hanldeClickMaterialJobWorkInwardSelection = (event) => {
        // let id = event.data.idMaterialJobWork;
        // this.setState({ challanItemDetails: [] }, () => {
        //     this.usp_Transaction_MaterialJobWorkSelectbyID_PendingQty(id);
        // });
    };


    onSelectionChanged = (selectedRows) => {
        this.setState({ challanItemDetails: [], selectedRowsForItem: selectedRows }, () => {
            selectedRows.forEach(element => {
                this.usp_Transaction_MaterialJobWorkSelectbyID_PendingQty(element.idMaterialJobWork);
            });
        });
    };

    usp_Transaction_MaterialJobWorkSelectbyID_PendingQty = (id) => {
        let request = {
            idMaterialJobWork: id,
            idMaterialJobWorkInward: this.state.materialObject.idMaterialJobWorkInward,
            updateStatus: this.state.materialObject.updateStatus,
        };

        this.transactionStockServices.usp_Transaction_MaterialJobWorkSelectbyID_PendingQty(request)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem) {
                    let dynamicData = response.responseItem.responseContent || [];

                    this.setState((prevState) => ({
                        challanItemDetails: [...prevState.challanItemDetails, ...dynamicData],
                        open: true
                    }));
                }
            });
    };

    resetDetailsFields = () => {
        let details = this.state.materialObject
        details.idMaterialJobWorkInward = 0
        details.jobWorkInNo = ''
        details.updateStatus = 0
        details.idEmployee = 0
        details.testingNo = ''
        details.idJobWorkFrom = 5
        details.idGatepass = 0
        details.idInv = 0
        details.IdJobWork = 0
        details.inwardNo = ''
        details.inwardDate = ''
        details.idVendor = ''
        details.inspection = ''
        details.deliveryCommence = ""
        details.transporter = ""
        details.address = ""
        details.idPlant = ''
        details.totalQty = 0
        details.totalAmt = 0
        details.taxAmt = 0
        details.totalWithTax = 0
        details.extraCharges = 0
        details.discount = 0
        details.finalAmt = 0
        details.tcsPercentage = 0
        details.tcsAmt = 0
        details.jwTotalAmt = 0
        details.diffAmt = "";
        details.taxableAmt = "";
        details.adjustableAmt = "";
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            materialObject: details,
            itemRowData: [],
        });
    }

    setFilterParameters = (event, name) => {
        if (name === 'idTaxGroup') {
            let itemObject = this.state.itemObject
            itemObject.idTaxGroup = event.value
            this.setState({ itemObject: itemObject })
        } else {
            let details = this.state.materialObject;
            details[name] = event.value;
            if (name === 'idVendor') {
                details.address = event.partyAddress;
            }
            if (name === 'idGatepass') {
                details.idVendor = this.state.partyAccountList.find((x) => x.label === event.party).value
                details.address = this.state.partyAccountList.find((x) => x.label === event.party).partyAddress
            }
            this.setState({ materialObject: details }, () => {
                if (name === 'idGatepass') {
                    this.getPartyAccountSelectbyID_withGatePass();
                    this.getPartyAccountSelectbyID()
                }
                if (name === 'idVendor') {
                    this.getPartyAccountSelectbyID()
                }
            });
        }
    }

    getPartyAccountSelectbyID = () => {
        if (this.state.materialObject.idVendor > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.materialObject.idVendor).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let data = this.state.materialObject;
                    data.address = res.p_Address;
                    data.email = res.emailID;
                    data.contactNo = res.contactNo;
                    data.contactPerson = res.contactPerson;
                    this.setState({ materialObject: data });
                }
            });
        }
    }

    getPartyAccountSelectbyID_withGatePass = () => {
        if (this.state.materialObject.idVendor > 0) {
            let request = [this.state.materialObject.idVendor, this.state.materialObject.idGatepass];
            this.transactionStockServices.getPartyAccountSelectbyID_withGatePass(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let data = this.state.materialObject;
                    data.invoiceNo = res.invoiceNo;
                    data.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : null;
                    this.setState({ materialObject: data });
                }
            });
        }
    }

    getPartyAccountSelectbyID = () => {
        if (this.state.materialObject.idVendor > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.materialObject.idVendor).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let data = this.state.materialObject;
                    data.idInv = this.state.invTyleList.find(x => x.label === res.invoiceType) ? this.state.invTyleList.find(x => x.label === res.invoiceType).value : 1;
                    this.setState({ materialObject: data });
                }
            });
        }
    }

    onVendorSelectionChanged = (selectedRows) => {
        this.setState({ vendorSelectedRowsForItem: selectedRows });
    }

    handleCellClick = (event) => {
        let data = this.state.materialObject;
        data.idMaterialJobWorkInward = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ materialObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Job Work Inward");
    };

    addProduct = () => {
        let arr = this.state.selectedRowsForItem;
        let itemRowData = [];
        if (arr && arr.length > 0) {
            let materialObject = this.state.materialObject;
            materialObject.idJobWorkFrom = this.state.jobWorkFromLIst.find(x => x.label.toLowerCase() === arr[0].jobWorkFrom.toLowerCase())?.value;
            const promises = arr.map(async (element) => {
                let request = {
                    idMaterialJobWork: element.idMaterialJobWork,
                    idMaterialJobWorkInward: this.state.materialObject.idMaterialJobWorkInward,
                    updateStatus: this.state.materialObject.updateStatus
                };

                return this.transactionStockServices.addProductForMaterialInward(request)
                    .then(response => ({ response, element }));
            });

            Promise.all(promises).then(results => {
                results.forEach(({ response, element }) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;

                        dynamicData = dynamicData.map(x => {
                            let amt = x.amount || (x.rate * x.quantity)
                            return {
                                ...x,
                                jobWorkNo: element.jobWorkNo,
                                quantity: Number(x.pendingQty),
                                inwardQty: 0,
                                pendingQty: Number(x.pendingQty),
                                rejectQty: 0,
                                amount: Number(x.amount) ? Number(x.amount) : x.amount,
                                rate: Number(x.rate) ? Number(x.rate) : x.rate,
                                taxableAmt: Number(x.taxableAmt) ? Number(x.taxableAmt) : x.taxableAmt,
                                sgstAmt: Number(x.sgstAmt) ? Number(x.sgstAmt) : x.sgstAmt,
                                cgstAmt: Number(x.cgstAmt) ? Number(x.cgstAmt) : x.cgstAmt,
                                netTotal: Number(x.netTotal) ? Number(x.netTotal) : x.netTotal,
                                jwRate: Number(x.rate).toFixed(2),
                                jwAmount: Number(amt).toFixed(2),
                                jwTaxableAmt: Number(amt).toFixed(2),
                            };
                        });
                        if (Array.isArray(dynamicData)) {
                            itemRowData.push(...dynamicData);
                        } else {
                            itemRowData.push(dynamicData);
                        }
                    }
                });

                let vendorSelectedRowsForItem = this.state.vendorSelectedRowsForItem

                let filteredItemRowData;

                if (vendorSelectedRowsForItem.length === 0) {
                    filteredItemRowData = itemRowData;
                } else {
                    let selectedIds = vendorSelectedRowsForItem.map(row => row.idMaterialJobWorkItems);

                    filteredItemRowData = itemRowData.filter(item =>
                        selectedIds.includes(item.idMaterialJobWorkItems)
                    );
                }

                this.setState({ itemRowData: filteredItemRowData, open: false, materialObject: materialObject }, () => {
                    this.calculatePricing()
                })
            });
        } else {
            this.SwalServices.Alert('Please select item')
        }
    }

    calculatePricing = () => {
        let itemRowData = this.state.itemRowData
        let totalQuantity = 0;
        let totalAmt = 0;
        let totalTaxableAmt = 0;
        let totalSgstAmt = 0;
        let totalCgstAmt = 0;
        let totalIgstAmt = 0;
        let extraCharges = 0;
        let totalDiscount = 0;
        let jwTotalAmt = 0;
        let taxableAmt = 0;
        itemRowData.forEach((item) => {
            totalQuantity += parseFloat(item.inwardQty || 0);
            totalAmt += (parseFloat(item.inwardQty) * parseFloat(item.rate));
            totalTaxableAmt += parseFloat(item.taxableAmt || 0);
            totalSgstAmt += parseFloat(item.sgstAmt || 0);
            totalCgstAmt += parseFloat(item.cgstAmt || 0);
            totalIgstAmt += parseFloat(item.igstAmt || 0);
            extraCharges += parseFloat(item.extraCharges || 0);
            totalDiscount += ((parseFloat(item.discount) * (parseFloat(item.inwardQty) * parseFloat(item.rate))) / 100);
            jwTotalAmt += parseFloat(item.jwAmount || 0);
            taxableAmt += parseFloat(item.taxableAmt || 0);
        });
        let finalAmt = totalTaxableAmt + totalSgstAmt + totalCgstAmt + totalIgstAmt;
        let materialObject = this.state.materialObject;

        let tcsPercentage = parseFloat(materialObject.tcsPercentage || 0);
        let tcsAmt = ((finalAmt * tcsPercentage) / 100).toFixed(0);
        let finalAmtWithTCS = finalAmt + Number(tcsAmt);

        materialObject.jwTotalAmt = jwTotalAmt.toFixed(2);
        materialObject.totalQuantity = totalQuantity.toFixed(2);
        materialObject.totalAmt = totalAmt.toFixed(2);
        materialObject.extraCharges = extraCharges.toFixed(2);
        materialObject.discount = totalDiscount.toFixed(2);
        materialObject.taxableAmt = taxableAmt.toFixed(2);
        materialObject.diffAmt = Number(materialObject.totalAmt) - Number(materialObject.jwTotalAmt);
        materialObject.taxAmt = (totalSgstAmt + totalCgstAmt + totalIgstAmt).toFixed(2);
        materialObject.totalWithTax = (totalSgstAmt + totalCgstAmt + totalIgstAmt + totalTaxableAmt).toFixed(2);
        let adjustableAmt = Number(materialObject.adjustableAmt) || 0;
        materialObject.tcsAmt = Number(tcsAmt).toFixed(2);
        materialObject.finalAmt = Math.round(finalAmtWithTCS + adjustableAmt).toFixed(2);

        this.setState({
            materialObject: materialObject
        });
    }

    // calculateRowPricing = (rowData) => {
    //     const inwardQty = Number(rowData.inwardQty) || 0;
    //     const rate = Number(rowData.rate) || 0;
    //     const discount = Number(rowData.discount) || 0;
    //     const extraCharges = Number(rowData.extraCharges) || 0;

    //     const sgst = Number(rowData.sgst) || 0;
    //     const cgst = Number(rowData.cgst) || 0;
    //     const igst = Number(rowData.igst) || 0;

    //     const amount = inwardQty * rate;
    //     const discountAmt = (amount * discount) / 100;
    //     const taxableAmt = amount - discountAmt + extraCharges;

    //     const sgstAmt = (taxableAmt * sgst) / 100;
    //     const cgstAmt = (taxableAmt * cgst) / 100;
    //     const igstAmt = (taxableAmt * igst) / 100;

    //     const netTotal = taxableAmt + sgstAmt + cgstAmt + igstAmt;

    //     rowData.amount = isNaN(amount) ? 0 : parseFloat(amount.toFixed(2));
    //     rowData.taxableAmt = isNaN(taxableAmt) ? 0 : parseFloat(taxableAmt.toFixed(2));
    //     rowData.sgstAmt = isNaN(sgstAmt) ? 0 : parseFloat(sgstAmt.toFixed(2));
    //     rowData.cgstAmt = isNaN(cgstAmt) ? 0 : parseFloat(cgstAmt.toFixed(2));
    //     rowData.igstAmt = isNaN(igstAmt) ? 0 : parseFloat(igstAmt.toFixed(2));
    //     rowData.netTotal = isNaN(netTotal) ? 0 : parseFloat(netTotal.toFixed(2));
    //     rowData.pendingQty = rowData.quantity - inwardQty;
    // };

    // calculateRowPricing = (rowData) => {
    //     const inwardQty = Number(rowData.inwardQty) || 0;
    //     const rate = Number(rowData.rate) || 0;
    //     const jwRate = Number(rowData.jwRate) || 0;
    //     const discount = Number(rowData.discount) || 0; // %
    //     const extraCharges = Number(rowData.extraCharges) || 0;

    //     const sgst = Number(rowData.sgst) || 0;
    //     const cgst = Number(rowData.cgst) || 0;
    //     const igst = Number(rowData.igst) || 0;

    //     const baseAmount = inwardQty * rate;
    //     const jwBaseAmount = inwardQty * jwRate;

    //     const discountAmt = (baseAmount * discount) / 100;
    //     const jwDiscountAmt = (jwBaseAmount * discount) / 100;

    //     const amountAfterDiscount = baseAmount - discountAmt;
    //     const jwAmountAfterDiscount = jwBaseAmount - jwDiscountAmt;

    //     const taxableAmt = amountAfterDiscount + extraCharges;
    //     const jwTaxableAmt = jwAmountAfterDiscount + extraCharges;

    //     const isIntraState = this.state.materialObject?.idInv === 1 || this.state.materialObject?.idInv === 0;
    //     const sgstAmt = isIntraState ? (taxableAmt * sgst) / 100 : 0;
    //     const cgstAmt = isIntraState ? (taxableAmt * cgst) / 100 : 0;
    //     const igstAmt = isIntraState ? 0 : (taxableAmt * igst) / 100;

    //     const netTotal = taxableAmt + sgstAmt + cgstAmt + igstAmt;

    //     rowData.baseAmount = parseFloat(baseAmount.toFixed(2));
    //     rowData.discountAmt = parseFloat(discountAmt.toFixed(2));
    //     rowData.amountAfterDiscount = parseFloat(amountAfterDiscount.toFixed(2));
    //     rowData.extraCharges = parseFloat(extraCharges.toFixed(2));
    //     rowData.taxableAmt = parseFloat(taxableAmt.toFixed(2));

    //     rowData.jwAmount = parseFloat(jwTaxableAmt.toFixed(2));

    //     rowData.sgstAmt = parseFloat(sgstAmt.toFixed(2));
    //     rowData.cgstAmt = parseFloat(cgstAmt.toFixed(2));
    //     rowData.igstAmt = parseFloat(igstAmt.toFixed(2));
    //     rowData.netTotal = parseFloat(netTotal.toFixed(2));

    //     rowData.pendingQty = (Number(rowData.quantity) || 0) - inwardQty;

    //     rowData.taxLabels = {
    //         sgst: isIntraState ? `SGST-${sgst}%` : "0%",
    //         cgst: isIntraState ? `CGST-${cgst}%` : "0%",
    //         igst: !isIntraState ? `IGST-${igst}%` : "0%"
    //     };

    //     return rowData;
    // };


    isValidQuantity = () => {
        const itemRowData = this.state.itemRowData;

        for (let index = 0; index < itemRowData.length; index++) {
            const item = itemRowData[index];
            if (item.inwardQty <= 0 && this.state.materialObject.updateStatus === 0) {
                this.SwalServices.Error(`Please enter valid quantity for item at row ${index + 1}.`);
                return false;
            }
        }

        return true;
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFieldsForWork();
        const isValidQuantity = this.isValidQuantity();
        if (isValidAllFields && isValidQuantity) {
            if (this.state.itemRowData.length > 0) {
                let details = this.state.materialObject;
                let details2 = this.state.itemRowData;
                let jobWorkInwardList = [];
                details2.map((x) => {
                    let request = {
                        fromTask: x.fromTask ? x.fromTask : '',
                        formReturnID: x.formReturnID ? x.formReturnID : 0,
                        idItem: x.idItem,
                        quantity: x.quantity,
                        recvQty: x.inwardQty ? x.inwardQty : 0,
                        rejectQty: x.rejectQty ? x.rejectQty : 0,
                        pendingQty: x.pendingQty ? x.pendingQty : 0,
                        weight: x.weight ? x.weight : 0,
                        remarks: x.remarks ? x.remarks : 0,
                        idMaterialTestingProducts: x.idMaterialTestingProducts ? x.idMaterialTestingProducts : 0,
                        idMaterialTesting: x.idMaterialTesting ? x.idMaterialTesting : 0,
                        idMaterialJobWork: x.idMaterialJobWork ? x.idMaterialJobWork : 0,
                        idMaterialIssueJobWork: 0,
                        natureOfJobWork: x.natureOfJobWork ? x.natureOfJobWork : '',
                        issueNo: x.issueNo ? x.issueNo : 0,
                        rate: x.rate ? x.rate : 0,
                        amount: x.amount ? x.amount : 0,
                        discount: x.discount ? x.discount : 0,
                        extraCharges: x.extraCharges ? x.extraCharges : 0,
                        taxableAmt: x.taxableAmt ? x.taxableAmt : 0,
                        idTaxGroup: x.idTaxGroup ? x.idTaxGroup : 0,
                        sgst: x.sgst ? x.sgst : 0,
                        sgstAmt: x.sgstAmt ? x.sgstAmt : 0,
                        cgst: x.cgst ? x.cgst : 0,
                        cgstAmt: x.cgstAmt ? x.cgstAmt : 0,
                        igst: x.igst ? x.igst : 0,
                        igstAmt: x.igstAmt ? x.igstAmt : 0,
                        netTotal: x.netTotal ? x.netTotal : 0,
                        jwRate: x.jwRate ? x.jwRate : 0,
                        jwAmount: x.jwAmount ? x.jwAmount : 0,
                        idMaterialJobWorkItems: x.idMaterialJobWorkItems ? x.idMaterialJobWorkItems : 0
                    }
                    jobWorkInwardList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idMaterialJobWorkInward: details.idMaterialJobWorkInward,
                        jobWorkInwardNo: details.jobWorkInwardNo,
                        updateStatus: details.updateStatus,
                        jobWorkInwardDate: (details.jobWorkInwardDate && details.jobWorkInwardDate !== 'Invalid date') ? details.jobWorkInwardDate : null,
                        invoiceDate: (details.invoiceDate && details.invoiceDate !== 'Invalid date') ? details.invoiceDate : null,
                        invoiceNo: details.invoiceNo,
                        jobWorkFrom: details.idJobWorkFrom > 0 ? this.state.jobWorkFromLIst.find(x => x.value === details.idJobWorkFrom).label : '',
                        refNo: '',
                        jobWorkNo: details.jobWorkNo ? details.jobWorkNo : '', //
                        idMaterialJobWork: details.idMaterialJobWork ? details.idMaterialJobWork : 0,
                        idVendor: details.idVendor ? details.idVendor : 0,
                        idEmployee: details.idEmployee ? details.idEmployee : 0,
                        inwardNo: details.inwardNo ? details.inwardNo : 0,
                        inwardDate: (details.inwardDate && details.inwardDate !== 'Invalid date') ? details.inwardDate : null,
                        testingNo: details.testingNo ? details.testingNo : 0,
                        fromTask: details.fromTask ? details.fromTask : 0,
                        idMaterialTesting: details.idMaterialTesting ? details.idMaterialTesting : 0,
                        idMaterialIssueJobWork: details.idMaterialIssueJobWork ? details.idMaterialIssueJobWork : 0,
                        formReturnID: details.formReturnID ? details.formReturnID : 0,
                        transporter: details.transporter ? details.transporter : 0,
                        remarks: details.remarks ? details.remarks : '',
                        jobWorkNature: details.jobWorkNature ? details.jobWorkNature : '',
                        inspection: details.inspection ? details.inspection : '',
                        deliveryCommence: details.deliveryCommence ? details.deliveryCommence : '',
                        noOfLotsMax: details.noOfLotsMax ? details.noOfLotsMax : 0,
                        totalQty: details.totalQuantity ? details.totalQuantity : 0,
                        totalAmt: details.totalAmt ? details.totalAmt : 0,
                        taxAmt: details.taxAmt ? details.taxAmt : 0,
                        totalWithTax: details.totalWithTax ? details.totalWithTax : 0,
                        extraCharges: details.extraCharges ? details.extraCharges : 0,
                        discount: details.discount ? details.discount : 0,
                        finalAmt: details.finalAmt ? details.finalAmt : 0,
                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updateStatus > 0 ? new Date() : null,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        idCompanyDivision: 0,
                        idGatePass: details.idGatepass ? details.idGatepass : 0,
                        tcsPercentage: details.tcsPercentage ? details.tcsPercentage : 0,
                        tcsAmt: details.tcsAmt ? details.tcsAmt : 0,
                        jobWorkInwardList: jobWorkInwardList,
                        idGeneralProduct: details.idGeneralProduct ? details.idGeneralProduct : 0,
                        diffAmt: details.diffAmt ? details.diffAmt : 0,
                        jwTotalAmt: details.jwTotalAmt ? details.jwTotalAmt : 0,
                        taxableAmt: details.taxableAmt ? details.taxableAmt : 0,
                        adjustableAmt: details.adjustableAmt ? details.adjustableAmt : 0,
                    }
                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.transactionStockServices.submitJobWorkInwardInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.materialObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    if (this.state.urlId) {
                                        this.setState({ route: '/ledger-report' });
                                    } else {
                                        this.resetDetailsFields();
                                        this.setState(
                                            { isModalOpen: false },
                                            () => {
                                                this.procSelectAllRecordsSP();
                                            }
                                        );
                                    }
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        }).finally(() => {
                            this.isSubmitting = false;
                            this.setState({ isSaving: false });
                        });
                }
            } else {
                this.SwalServices.Alert('Please add items')
            }
        }
    }

    usp_Transaction_MaterialJobWorkInwardSelectbyID = (id) => {
        this.transactionStockServices.usp_Transaction_MaterialJobWorkInwardSelectbyID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.materialObject;
                    data.idMaterialJobWorkInward = res.idMaterialJobWorkInward;
                    data.jobWorkInwardNo = res.jobWorkInwardNo
                    data.updateStatus = 1;
                    data.jobWorkInwardDate = res.jobWorkInwardDate ? moment(res.jobWorkInwardDate).format('YYYY-MM-DD') : '';
                    data.idJobWorkFrom = res.jobWorkFrom ? this.state.jobWorkFromLIst.find(x => x.label === res.jobWorkFrom).value || 1 : 1
                    data.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : '';
                    data.invoiceNo = res.invoiceNo ? res.invoiceNo : '';
                    data.jobWorkNo = res.jobWorkNo ? res.jobWorkNo : '';
                    data.idVendor = res.idVendor ? res.idVendor : '';
                    data.address = res.idVendor ? this.state.partyAccountList.find(x => x.value === res.idVendor).partyAddress : ''
                    data.idEmployee = res.idEmployee ? res.idEmployee : '';
                    data.inwardNo = res.inwardNo ? res.inwardNo : '';
                    data.inwardDate = res.inwardDate ? moment(res.inwardDate).format('YYYY-MM-DD') : '';
                    data.testingNo = res.testingNo ? res.testingNo : '';
                    data.fromTask = res.fromTask ? res.fromTask : '';
                    data.idMaterialTesting = res.idMaterialTesting ? res.idMaterialTesting : '';
                    data.idMaterialIssueJobWork = res.idMaterialIssueJobWork ? res.idMaterialIssueJobWork : '';
                    data.formReturnID = res.formReturnID ? res.formReturnID : '';
                    data.transporter = res.transporter ? res.transporter : '';
                    data.remarks = res.remarks ? res.remarks : '';
                    data.jobWorkNature = res.jobWorkNature ? res.jobWorkNature : '';
                    data.inspection = res.inspection ? res.inspection : '';
                    data.deliveryCommence = res.deliveryCommence ? res.deliveryCommence : '';
                    data.totalQuantity = res.totalQty ? res.totalQty : 0;
                    data.totalAmt = res.totalAmt ? res.totalAmt : 0;
                    data.taxAmt = res.taxAmt ? res.taxAmt : 0;
                    data.totalWithTax = res.totalwithTax ? res.totalwithTax : 0;
                    data.noOfLotsMax = res.noOfLotsMax ? res.noOfLotsMax : 0;
                    data.extraCharges = res.extraCharges ? res.extraCharges : 0;
                    data.discount = res.discount ? res.discount : 0;
                    data.finalAmt = res.finalAmt ? res.finalAmt : 0;
                    data.idGatepass = res.idGatePass ? res.idGatePass : 0;
                    data.tcsPercentage = res.tcsPercentage ? res.tcsPercentage : 0;
                    data.tcsAmt = res.tcsAmt ? res.tcsAmt : 0;
                    data.idGeneralProduct = res.idGeneralProduct ? res.idGeneralProduct : 0;
                    data.idInv = 1
                    data.jwTotalAmt = res.jwTotalAmt ? res.jwTotalAmt : 0;
                    data.diffAmt = res.diffAmt ? res.diffAmt : 0;
                    data.taxableAmt = res.taxableAmt ? res.taxableAmt : 0;
                    data.adjustableAmt = res.adjustableAmt ? res.adjustableAmt : 0;
                    this.setState({
                        materialObject: data,
                        isModalOpen: true,
                        globalUserID: res.modifiedBy
                    }, () => {
                        this.getGatePassList()
                        this.getPartyAccountSelectbyID()
                    });
                    this.transactionStockServices.usp_Transaction_MaterialJobWorkInwardItemsSelectbyID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            if (value.length > 0) {
                                value.map((x) => {
                                    x.inwardQty = x.recvQty
                                    x.pendingQty = x.quantity ? x.quantity - x.recvQty : 0
                                });
                                this.setState({ itemRowData: value }, () => {
                                    this.calculatePricing()
                                });
                            }
                        }
                    });

                }
            }
        });
    }

    back = () => {
        this.setState({ open: false })
    }

    downloadJobWorkInwardInvoice = () => {
        if (this.state.materialObject.idMaterialJobWorkInward > 0) {
            let request = [this.state.materialObject.idMaterialJobWorkInward];
            this.transactionStockServices.downloadJobWorkInwardInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    //var filename = `PurchaseInvoice-${moment(new Date()).format("DDMMYYYYHHmmss")}`;
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    shareOnWhatsApp = () => {
        if (this.state.materialObject.idMaterialJobWorkInward > 0) {
            let request = [
                this.state.materialObject.idMaterialJobWorkInward,
                "JobWorkInward"
            ];
            this.transactionStockServices.shareOnWhatsApp(request).then((response) => {
                if (response.statusCode == 200 && response !== null) {
                    if (response.responseItem.responseContent) {
                        const link = response.responseItem.responseContent;
                        const phoneNumber = this.state.materialObject.contactNo || "";
                        const message = `Dear Customer ${this.state.materialObject.contactPerson || ""},  
-> Please find attached your Job Work Inward.  
-> You can view or download it using the link below:    
-> ${link}  

Thank you for your business!`;
                        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                        window.open(whatsappLink, "_blank");
                    } else {
                        this.SwalServices.Error("No data found");
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }

    };

    sendOnEmail = () => {
        if (this.state.materialObject.idMaterialJobWorkInward && this.state.materialObject.email) {
            let request = [
                this.state.materialObject.email,
                this.state.materialObject.idMaterialJobWorkInward,
                this.state.companyName,
                "JobWorkInward"
                //"InvoiceTempletes\\PurchaseOrderInvoices"
            ];
            this.transactionStockServices.sendPurchaseInvoiceMail(request).then((response) => {
                if (response.responseItem !== null && response.statusCode === 200) {
                    this.SwalServices.Success("Invoice snet sucessfully.");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("Email not data found");
        }
    };

    onCellValueChanged = (event) => {
        if (event.colDef.field === 'inwardQty' || event.colDef.field === 'rate' || event.colDef.field === 'discount' || event.colDef.field === 'extraCharges') {
            let updatedData = this.calculateRowPricing(event.data);
            event.node.setData(updatedData);
            this.calculatePricing();
        }
    }

    onItemRowDataClicked = (event) => {
        let details = this.state.itemObject;
        details.drawingNo = event.data.drawingNo;
        details.itemName = event.data.itemName;
        details.quantity = event.data.quantity;
        details.inwardQty = event.data.inwardQty;
        details.pendingQty = event.data.pendingQty;
        details.rate = event.data.rate;
        details.jwRate = event.data.jwRate;
        details.discount = event.data.discount;
        details.extraCharges = event.data.extraCharges;
        details.remarks = event.data.remarks
        details.keyId = event.rowIndex
        details.idTaxGroup = event.data.idTaxGroup
        details.sgst = event.data.sgst
        details.cgst = event.data.cgst
        details.igst = event.data.igst
        details.sgstAmt = event.data.sgstAmt
        details.cgstAmt = event.data.cgstAmt
        details.igstAmt = event.data.igstAmt
        details.netTotal = event.data.netTotal
        this.setState({ itemObject: details });
    };

    insertItem = (flag) => {
        if (flag === 'Update') {
            let details = this.state.itemObject;
            const index = details.keyId;
            let itemList = [...this.state.itemRowData];

            if (index !== null && index >= 0) {
                itemList[index] = {
                    ...itemList[index],
                    drawingNo: details.drawingNo,
                    itemName: details.itemName,
                    quantity: details.quantity,
                    inwardQty: Number(details.inwardQty),
                    pendingQty: details.pendingQty,
                    rate: Number(details.rate),
                    jwRate: details.jwRate,
                    discount: details.discount,
                    extraCharges: details.extraCharges,
                    idTaxGroup: details.idTaxGroup,
                    sgst: details.sgst,
                    cgst: details.cgst,
                    igst: details.igst,
                    sgstAmt: details.sgstAmt,
                    cgstAmt: details.cgstAmt,
                    igstAmt: details.igstAmt,
                    netTotal: details.netTotal,
                    remarks: details.remarks,
                };
            }
            this.setState({ itemRowData: itemList }, () => {
                this.calculateRowPricing(index);
            });
        }
    }

    deleteItem = () => {
        const index = this.state.itemObject.keyId;
        let itemList = [...this.state.itemRowData];

        if (index !== null && index >= 0 && index < itemList.length) {
            itemList.splice(index, 1);
        }

        this.setState({ itemRowData: itemList }, () => {
            this.resetItemObject()
        });
    }

    calculateRowPricing = (index) => {
        let itemList = [...this.state.itemRowData];

        if (index === null || index === undefined || !itemList[index]) return;

        let rowData = { ...itemList[index] };

        const inwardQty = Number(rowData.inwardQty) || 0;
        const rate = Number(rowData.rate) || 0;
        const jwRate = Number(rowData.jwRate) || 0;
        const discount = Number(rowData.discount) || 0; // %
        const extraCharges = Number(rowData.extraCharges) || 0;

        // const sgst = Number(rowData.sgst) || 0;
        // const cgst = Number(rowData.cgst) || 0;
        // const igst = Number(rowData.igst) || 0;

        const baseAmount = inwardQty * rate;
        const jwBaseAmount = inwardQty * jwRate;

        const discountAmt = (baseAmount * discount) / 100;

        const amountAfterDiscount = baseAmount - discountAmt;

        const taxableAmt = amountAfterDiscount + extraCharges;

        let sgstAmt = 0, cgstAmt = 0, igstAmt = 0;
        let sgst = 0, cgst = 0, igst = 0;

        if (rowData.idTaxGroup > 0) {
            let tax = this.state.taxStructureList.find(x => x.idTaxStructure === rowData.idTaxGroup);
            if (tax) {
                sgst = tax.sgst || 0;
                cgst = tax.cgst || 0;
                igst = tax.igst || 0;

                if (this.state.materialObject?.idInv === 1 || this.state.materialObject?.idInv === 0) {
                    sgstAmt = (taxableAmt * sgst) / 100;
                    cgstAmt = (taxableAmt * cgst) / 100;
                } else if (this.state.materialObject.idInvType === 2) {
                    igstAmt = (taxableAmt * igst) / 100;
                }
            }
        }


        const isIntraState = this.state.materialObject?.idInv === 1 || this.state.materialObject?.idInv === 0;
        // const sgstAmt = isIntraState ? (taxableAmt * sgst) / 100 : 0;
        // const cgstAmt = isIntraState ? (taxableAmt * cgst) / 100 : 0;
        // const igstAmt = isIntraState ? 0 : (taxableAmt * igst) / 100;

        const netTotal = taxableAmt + sgstAmt + cgstAmt + igstAmt;

        rowData.amount = parseFloat((baseAmount).toFixed(2));
        rowData.jwAmount = parseFloat((jwBaseAmount).toFixed(2));
        rowData.baseAmount = parseFloat(baseAmount.toFixed(2));
        rowData.discountAmt = parseFloat(discountAmt.toFixed(2));
        rowData.amountAfterDiscount = parseFloat(amountAfterDiscount.toFixed(2));
        rowData.extraCharges = parseFloat(extraCharges.toFixed(2));
        rowData.taxableAmt = parseFloat(taxableAmt.toFixed(2));

        rowData.sgst = isIntraState ? parseFloat(sgst.toFixed(2)) : 0;
        rowData.cgst = isIntraState ? parseFloat(cgst.toFixed(2)) : 0;
        rowData.igst = isIntraState ? 0 : parseFloat(igst.toFixed(2));

        rowData.sgstAmt = parseFloat(sgstAmt.toFixed(2));
        rowData.cgstAmt = parseFloat(cgstAmt.toFixed(2));
        rowData.igstAmt = parseFloat(igstAmt.toFixed(2));
        rowData.netTotal = parseFloat(netTotal.toFixed(2));

        rowData.pendingQty = (Number(rowData.quantity) || 0) - inwardQty;

        rowData.taxLabels = {
            sgst: isIntraState ? `SGST-${sgst}%` : "0%",
            cgst: isIntraState ? `CGST-${cgst}%` : "0%",
            igst: !isIntraState ? `IGST-${igst}%` : "0%"
        };
        itemList[index] = rowData;

        this.setState({ itemRowData: itemList }, () => {
            this.calculatePricing()
            this.resetItemObject()
        });
    };

    resetItemObject = () => {
        let details = this.state.itemObject;
        details.drawingNo = '';
        details.itemName = '';
        details.quantity = 0;
        details.inwardQty = 0;
        details.pendingQty = 0;
        details.rate = 0;
        details.jwRate = 0;
        details.discount = 0;
        details.extraCharges = 0;
        details.remarks = '';
        details.sgst = 0
        details.cgst = 0
        details.igst = 0
        details.sgstAmt = 0
        details.cgstAmt = 0
        details.igstAmt = 0
        details.netTotal = 0
        details.keyId = null
        this.setState({ itemObject: details });
    }

    usp_Transaction_JobworkInwardDelete = () => {
        this.SwalServices
            .Confirm("Delete Jobwork Inward", "Are you sure ?", "Yes", "No")
            .then((response) => {
                if (response) {
                    this.transactionStockServices.usp_Transaction_JobworkInwardDelete(this.state.materialObject.idMaterialJobWorkInward).then((response) => {
                        if (response.statusCode === 200 && response.responseItem !== null) {
                            this.SwalServices.Success('Deleted Successfully')
                            this.setState({ isModalOpen: false })
                            this.resetItemObject()
                            this.resetDetailsFields()
                            this.procSelectAllRecordsSP()
                        } else {
                            this.SwalServices.Error(response.message);
                        }
                    })
                }
            });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <JobWorkInwardPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            itemObject={this.state.itemObject}
                            handleChangeForWork={this.handleChangeForWork.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColdefs={this.state.itemColdefs}
                            open={this.state.open}
                            partyAccountList={this.state.partyAccountList}
                            accountHeadList={this.state.accountHeadList}
                            employeeList={this.state.employeeList}
                            invTyleList={this.state.invTyleList}
                            jobWorkFromLIst={this.state.jobWorkFromLIst}
                            gatePassList={this.state.gatePassList}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            addJobWork={this.addJobWork.bind(this)}
                            materialJobWorkInwardSelectionList={this.state.materialJobWorkInwardSelectionList}
                            challanItemDetails={this.state.challanItemDetails}
                            hanldeClickMaterialJobWorkInwardSelection={this.hanldeClickMaterialJobWorkInwardSelection.bind(this)}
                            onSelectionChanged={this.onSelectionChanged.bind(this)}
                            addProduct={this.addProduct.bind(this)}
                            calculatePricing={this.calculatePricing.bind(this)}
                            calculateRowPricing={this.calculateRowPricing.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            gridApi={this.gridApi}
                            onVendorSelectionChanged={this.onVendorSelectionChanged.bind(this)}
                            back={this.back.bind(this)}
                            downloadJobWorkInwardInvoice={this.downloadJobWorkInwardInvoice.bind(this)}
                            sendOnEmail={this.sendOnEmail.bind(this)}
                            shareOnWhatsApp={this.shareOnWhatsApp.bind(this)}
                            onCellValueChanged={this.onCellValueChanged.bind(this)}
                            onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            taxStructureList={this.state.taxStructureList}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                            permissions={this.state.permissions}
                            usp_Transaction_JobworkInwardDelete={this.usp_Transaction_JobworkInwardDelete.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 450px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Job work inward</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
